import { defineStore } from 'pinia'
import { getTheme, setShareToken, setTheme, tree2ArrayFn } from '@haohan/clw-utils'
import { checkProjectShare, envInfoReq, projectQueryPowerTreeReq } from '@haohan/clw-api'
import { has } from 'lodash-es'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      theme: getTheme() || 'haohan-light',
      edieModel: false,
      pageLock: false,
      queryTxt: '',
      // 公网环境，项目只能选择V2查询引擎，不能选择行业定制。
      // 选择V1查询引擎（旧版），数据源类型只能选择POSTGRESQL,CLICKHOUSE
      environment: {
        view: true //true-生成后的系统，false-平台
      },
      // 全局的取色器
      colorPicker: {
        show: false, // 取色器是否显示
        color: null, // 触发取色器dom的color
        target: null, // 触发取色器dom
        scroll: '', //scroll_
        upColor: null, //上一次取色的颜色
        showType: true //是否显示取色器类型
      } as any,
      editorProvider: null, // sql代码编辑器全局自定义提示配置
      lastUpdateTime: null, // 上次更新时间
      permissionOrigin: []
    }
  },
  getters: {
    isPlatform: (state: any) => {
      if (has(state.environment, 'view') && !state.environment.view) {
        return true
      }
      return false
    },
    isPrivate: (state: any) => has(state.environment, 'public') && !state.environment.public,
    permissionArr: (state) => {
      return tree2ArrayFn(state.permissionOrigin)
    },
    currentLocale: (state: any) => {
      return state.environment.locale
    }
  },
  actions: {
    changeTheme(theme: string) {
      this.theme = theme
      setTheme(theme)
      document.body.setAttribute('class', theme)
    },
    changeEdieModel(edieModel: boolean) {
      this.edieModel = edieModel
    },
    changePageLock(param: boolean) {
      this.pageLock = param
    },
    upQueryTxt(txt: string) {
      this.queryTxt = txt
    },
    upEnv(params: any) {
      this.environment = params
    },
    upColorPickerProp(prop: any, value: any) {
      this.colorPicker[prop] = value
    },
    getEnvInfo() {
      // if (this.environment === null) {
      //   envInfoReq().then((resp: any) => {
      //     this.upEnv(resp.data)
      //   })
      // }
      return envInfoReq().then((resp: any) => {
        this.upEnv(resp.data)
      })
    },
    updateTime(time: any) {
      this.lastUpdateTime = time
    },
    async getPermissionOrigin() {
      try {
        const { data } = await projectQueryPowerTreeReq()
        this.setPermissionOrigin(data)
      } catch (error) {}
    },
    setPermissionOrigin(origin: any) {
      this.permissionOrigin = origin
    },
    // 验证项目分享
    checkProjectShare(id: string, param: any) {
      return new Promise((resolve, reject) => {
        checkProjectShare(id, param)
          .then(async (res) => {
            const { status, data } = res
            if (status === 200) {
              // 验证通过
              localStorage.setItem(
                'shareOrigin',
                JSON.stringify({ projectId: data.projectId, shareId: id })
              )
              const cDate = new Date(data.createDate).getTime()
              // 根据expired设置token有效期
              const expiry = cDate + (data.expired === -1 ? 30 : data.expired) * 24 * 60 * 60 * 1000
              setShareToken(data.token, expiry)
              resolve(data)
            } else {
              reject(res)
            }
          })
          .finally(() => {
            resolve(false)
          })
      })
    }
  }
})
